import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import StatsSection from './components/StatsSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import { Helmet } from './components/SEOHead';
import { HomeSchema } from '@/components/feature/SchemaOrg';

export default function Home() {
  return (
    <>
      <Helmet
        title="52662鼎盛平台官方版 - 官方正版下载与注册 | 鼎盛平台官网"
        description="52662鼎盛平台官方版是经过官方认证的正规平台，提供安全稳定的服务体验。立即访问鼎盛平台官网，享受官方正版保障、极速通道与专属会员权益，注册即享多重福利。"
        canonicalUrl="/"
      />
      <HomeSchema />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <StatsSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}